import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useT } from "@/lib/LanguageContext";

export default function ForWho() {
  const { t } = useT();
  const w = t.forWho;

  return (
    <section
      id="para-quien"
      data-testid="for-who-section"
      className="relative py-24 md:py-36 bg-[#F7F3F7]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-12">
          <div className="col-span-12 md:col-span-5">
            <p className="text-[11px] uppercase tracking-[0.24em] text-[#6B4E6F] mb-6">
              {w.eyebrow}
            </p>
            <h2
              data-testid="for-who-headline"
              className="font-serif font-light text-[clamp(2.2rem,5vw,4.5rem)] leading-[0.95] tracking-tight"
            >
              {w.headline.l1}
              <br />
              {w.headline.l2}
              <br />
              <span className="italic">{w.headline.l3}</span>
            </h2>
          </div>

          <div className="col-span-12 md:col-span-7">
            <ul className="border-t vk-line" data-testid="for-who-list">
              {w.items.map((it, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: 16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.45, delay: i * 0.06 }}
                  data-testid={`for-who-item-${i}`}
                  className="group flex items-start gap-6 py-6 md:py-7 border-b vk-line"
                >
                  <span className="font-serif text-sm text-[#E0B25B] mt-2 w-6 flex-shrink-0">
                    0{i + 1}
                  </span>
                  <Check
                    size={20}
                    strokeWidth={1.2}
                    className="mt-1 flex-shrink-0 text-[#4B2F4F] group-hover:text-[#E0B25B] transition-colors duration-300"
                  />
                  <p className="font-serif text-xl md:text-2xl leading-snug">
                    {it}
                  </p>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
